/** Help text for the sign-in and password screens. */

const auth = {
  email: "The email address registered against your employee record. It is normally your official company email.",
  password: "Your account password. If you have forgotten it, use the forgot-password link to have a reset sent to your registered email.",
  password_confirmation: "Type the new password again. Both entries must match before it can be saved.",
  remember: "Keep you signed in on this device. Leave it off on a shared or public computer.",
};

export const authTooltips = { auth };
export default authTooltips;
